import type React from 'react';

import { Pictures } from './components/Pictures';
import { TakingActionBody } from './components/TakingActionBody';

export const TakingAction: React.FC = () => {
	return (
		<div className="bg-background-raised py-20">
			<div className="container">
				<div className="flex flex-col items-center justify-center gap-8">
					<TakingActionBody />
					<Pictures />
				</div>
			</div>
		</div>
	);
};
